import { Modal } from '@components/ui';
import { XCircleIcon } from '@heroicons/react/24/outline';
import { GHOST } from '@components/ui/designTokens';
import { cn } from '@lib/utils/cn';

interface ErrorDetail {
  code: string;
  message: string;
}

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  details?: ErrorDetail[];
}

export function ErrorModal({ isOpen, onClose, title = 'Error', message, details }: ErrorModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      kicker="Factura · Rechazo"
      title={title}
      icon={<XCircleIcon />}
      size="lg"
      data-testid="invoice-wizard-error-modal"
      footer={
        <div className="ml-auto flex items-center gap-2.5">
          <button
            type="button"
            onClick={onClose}
            data-testid="invoice-wizard-error-modal-close-button"
            className={cn(GHOST, 'border-[#b8503a]/25 bg-[#b8503a]/[.06] text-[#a24030] hover:border-[#b8503a]/50')}
          >
            Cerrar
          </button>
        </div>
      }
    >
      <div className="space-y-4">
        {/* Error Icon and Main Message */}
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <XCircleIcon className="h-8 w-8 text-danger-500" />
          </div>
          <div className="flex-1">
            <p className="text-sm text-secondary-700 dark:text-secondary-300">
              {message}
            </p>
          </div>
        </div>

        {/* Error Details List */}
        {details && details.length > 0 && (
          <div className="mt-4">
            <h4 className="text-sm font-semibold text-secondary-900 dark:text-white mb-2">
              Detalles del error:
            </h4>
            <div className="space-y-2">
              {details.map((detail, index) => (
                <div
                  key={index}
                  data-testid={`invoice-wizard-error-modal-detail-${index}-error`}
                  className="bg-danger-50 dark:bg-danger-900/20 border border-danger-200 dark:border-danger-800 rounded-lg p-3"
                >
                  <div className="flex items-start space-x-2">
                    <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-danger-100 dark:bg-danger-900/40 text-danger-800 dark:text-danger-200 text-xs font-medium flex-shrink-0 mt-0.5">
                      {detail.code}
                    </span>
                    <p className="text-sm text-danger-800 dark:text-danger-200 flex-1">
                      {detail.message}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </Modal>
  );
}
